import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';

import reportError from 'ha/helpers/bugsnag/reportError';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';

import { getSupportedCountriesFetchStatus } from '../selectors';

export enum ActionTypes {
  START = '[supportedCountries] LOAD_SUPPORTED_COUNTRIES',
  DONE = '[supportedCountries] LOAD_SUPPORTED_COUNTRIES_DONE',
  FAIL = '[supportedCountries] LOAD_SUPPORTED_COUNTRIES_FAIL',
}

export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (countries: string[]) => createAction(ActionTypes.DONE, countries),
  fail: () => createAction(ActionTypes.FAIL),
};
export type ActionsUnionType = ActionsUnion<typeof Actions>;

const fetchSupportedCountries =
  (): Thunk =>
  (dispatch, getState, { apiV2 }) => {
    const state = getState();

    if (!getIsAuthenticated(state)) {
      return Promise.resolve();
    }

    if (getSupportedCountriesFetchStatus(state) === 'success') {
      return Promise.resolve();
    }

    dispatch(Actions.start());

    /**
     * @todo use a different endpoint for supported countries when it becomes available
     */
    return apiV2
      .getKycCountries('me')
      .then(({ data }) => {
        /**
         * @todo delete this temporary fix when the new endpoint for supported countries is available
         * `IS` is the country code for Iceland
         */
        const supportedCountriesList = [
          ...new Set([...data.acceptedCountryCodes, 'IS']),
        ];
        dispatch(Actions.done(supportedCountriesList));
      })
      .catch(error => {
        reportError('Error getting the supported countries', {
          metaData: { error },
        });
        dispatch(Actions.fail());
      });
  };

export default fetchSupportedCountries;
